import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledSkeletonLoaderContainer = styled.div`
  ${rtl`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media ${theme.mediaQuery.largeMobile} {
      padding-right: 0;
      padding-left: 0;
    }
  `}
`;

export const StyledSkeletonLoaderDiv = styled.div`
  ${rtl`
    border-radius: ${toRem(14)};
    margin: ${toRem(10)} 0;
    font-family: ${theme.fonts['fontFamilySwiss']}; 
    display:flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    background-color: inherit;
      @media ${theme.mediaQuery.allMobiles} {
        flex-flow:nowrap;
         height: auto;
      }
    .skeleton-loader-composite {
      background-color: ${theme.color['light-gray-1']};
      color: white;
      -webkit-animation: fadein 2s ease-in alternate infinite;
      -moz-animation: fadein 2s ease-in alternate infinite;
      animation: fadein 2s ease-in alternate infinite;
      border-radius: 8px;
    }
    @-webkit-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @-moz-keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    @keyframes fadein {
      10%   { opacity: 0.3; }
      25%   { opacity: 0.35; }
      50%   { opacity: 0.4; }
      75%   { opacity: 0.5; }
      100% { opacity: 0.6; }
    }
    .main-wrapper {
      padding: ${toRem(20)};
      width:100%;
      @media ${theme.mediaQuery.allMobiles} {
        width:100%;
      }
        .top-main-wrapper {
          width:100%;
          @media ${theme.mediaQuery.allMobiles} {
            width:100%;
          }
        }
        .bottom-rate-place-loader-container {
          width:90%;
          display: flex;
          justify-content: flex-end;
          .rate-place-loader {
            border-radius: ${toRem(22)};
          }
           @media ${theme.mediaQuery.allMobiles} {
            width:100%;
            .rate-place-loader {
              width:40%
            }
          }
        }
      }
    }
  `}
`;
